export default `<svg width="34" height="34" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect width="34" height="34" rx="8" fill="#1570EF"/>
<path d="M23.2871 20.842C22.6311 22.709 21.9641 24.322 21.4071 25.287C19.0051 29.449 16.5271 17.473 16.5271 17.473M16.5271 17.473C16.5271 17.473 4.55108 14.995 8.71308 12.592C12.2251 10.565 24.3291 7.07996 26.0201 7.97996C26.5131 8.90696 25.6901 12.959 24.5111 17.012M16.5271 17.473L22.5573 11.4425" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
`;
